import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDotsResize = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="#766483"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.5 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M15.5 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M9.5 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M9.5 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M15.5 18a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M9.5 18a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
    />
  </svg>
);
export default SvgDotsResize;
